import { Table } from "antd";
import React from "react";

const StandartTable = ({ data, loading, columns }) => {
   return (
      <>
         <Table
            style={{ marginTop: "15px" }}
            size="small"
            bordered
            rowKey={(record) => record.id}
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{ defaultPageSize: "12", showSizeChanger: true }}
         />
      </>
   );
};

export default StandartTable;
